/* ============================================================================
   Pet's Table — /pages/order: remates del brief del 11-ago-2026
   ----------------------------------------------------------------------------
   Tres cosas que pide el brief y que no estaban:

   1. No mostrar "$0/día" mientras se calcula el precio. El HTML arranca con 0
      literal, así que durante un instante la página anuncia que el plan es
      gratis. Se tapa con un estado de carga hasta que hay una cifra real.

   2. Avisar cuando no se pudo guardar el teléfono, sin bloquear. El brief es
      explícito: la disponibilidad del sistema de leads nunca debe impedir ver
      el precio o comprar.

   3. El evento plan_viewed con sus parámetros, para poder comparar el embudo
      entre quien deja WhatsApp y quien lo salta.

   Aparte de pt-plan-builder porque ese archivo se reescribe cada tanto.
   ========================================================================== */
(function () {
  'use strict';

  /* ── 1. Nada de "$0/día" mientras calcula ─────────────────────────────── */

  var PRECIOS = ['pday', 'sub-day', 'once-day', 'sub-reg'];

  function enCero(el) {
    var t = (el.textContent || '').replace(/[^0-9.]/g, '');
    return t === '' || parseFloat(t) === 0;
  }

  function marcar() {
    PRECIOS.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      /* La clase la pone y la quita esta función sola: en cuanto el
         plan-builder escribe una cifra real, se destapa. */
      el.classList.toggle('pt-precio-cargando', enCero(el));
    });
  }

  /* Se observa el DOM en vez de engancharse a una función concreta del
     plan-builder: los nombres internos cambian entre versiones, el hecho de
     que el número se escriba no. */
  function vigilarPrecios() {
    marcar();
    var raiz = document.getElementById('priceBlock') || document.body;
    new MutationObserver(marcar).observe(raiz.parentNode || raiz, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  }

  /* ── 2. Aviso cuando falla guardar el lead ────────────────────────────── */

  function avisoLead() {
    var sec = document.getElementById('leadSec');
    if (!sec || document.getElementById('ptLeadAviso')) return;
    var d = document.createElement('div');
    d.id = 'ptLeadAviso';
    d.className = 'pt-lead-aviso';
    d.setAttribute('role', 'status');
    d.textContent = 'No pudimos guardar tu número, pero tu plan está listo.';
    sec.appendChild(d);
    /* Se muestra y el usuario sigue: el brief prohíbe que esto detenga el
       flujo, así que no hay botón de reintentar ni nada que confirmar. */
    setTimeout(function () { d.classList.add('pt-visible'); }, 30);
  }

  /* Cualquier fallo al hablar con save-quiz activa el aviso, venga de donde
     venga: el paso de WhatsApp, el registro de sesión o el del perro. */
  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === 'function') {
    window.fetch = function (entrada) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var p = fetchOriginal.apply(this, arguments);
      if (url.indexOf('save-quiz') !== -1) {
        p.then(function (r) { if (!r || !r.ok) avisoLead(); }, avisoLead);
      }
      return p;
    };
  }

  /* ── 3. Embudo comparable: view_price y add_to_cart ───────────────────
     Los eventos del formulario venían corridos un paso, y por eso los datos
     salían imposibles: add_to_cart (12) mayor que view_price (11), cuando
     nadie puede agregar sin ver el precio.

       view_price   disparaba dentro del render, exigiendo que la zona
                    estuviera resuelta y leyendo style.display. Se perdía
                    casos y podía correr antes de que hubiera una cifra.
       add_to_cart  disparaba al pulsar el CTA, que solo ABRE el modal. Se
                    puede pulsar antes de que el precio se pinte.
       checkout     disparaba al agregar de verdad — eso es add_to_cart.

     Aquí se emiten los dos con la definición que pidió Jorge.

     view_price va una sola vez por sesión: responde "llegó a ver precio", y
     repetirlo al cambiar de plan no aportaría nada. add_to_cart_real va en
     CADA agregado, con un contador n, porque agregar un segundo perro es algo
     que la página pide expresamente y contarlo una sola vez hacía parecer que
     se perdían eventos.

     Se hace desde este archivo y no tocando pt-plan-builder porque ese se
     reescribe cada tanto y volveríamos al punto de partida. */

  var yaEmitido = {};

  function mandar(nombre, datos) {
    try { if (typeof window.PT_track === 'function') window.PT_track(nombre, datos || {}); } catch (e) {}
  }

  function emitir(nombre, datos) {
    if (yaEmitido[nombre]) return;
    yaEmitido[nombre] = true;
    mandar(nombre, datos);
  }

  /* Para lo que puede pasar más de una vez de verdad. La página invita a
     agregar un segundo perro ("Agrega este al carrito y luego suma otro"), y
     con la guarda de una sola vez esa compra daba dos checkout y un solo
     add_to_cart_real: parecía que se perdían eventos cuando lo que pasaba es
     que se agregó dos veces. */
  function emitirCada(nombre, datos) {
    yaEmitido[nombre] = (yaEmitido[nombre] || 0) + 1;
    datos = datos || {};
    datos.n = yaEmitido[nombre];   /* 1 = el primero de la sesión */
    mandar(nombre, datos);
  }

  /* El precio de verdad en pantalla: el bloque visible Y con una cifra que no
     sea el cero con el que arranca el HTML. */
  function precioVisible() {
    var pb = document.getElementById('priceBlock');
    if (!pb) return false;
    var r = pb.getBoundingClientRect();
    if (!r.height || getComputedStyle(pb).display === 'none') return false;
    var d = document.getElementById('pday');
    return !!(d && !enCero(d));
  }

  function vigilarPrecio() {
    if (precioVisible()) {
      var st = window.state || {};
      emitir('view_price', {
        plan: st.plan || null, cadence: st.cadence || null, zone: st.zona || null,
      });
    }
  }

  /* El agregar de verdad. PT_addToCart es la función que manda el artículo al
     carrito, así que envolverla es el único punto que no se puede confundir
     con abrir el modal.

     OJO AL COMPARARLO CON checkout. Esa misma función la envuelve también
     pt-plan-builder para emitir 'checkout', así que los dos eventos salen del
     mismo clic — el del botón "Continuar al pago →" del modal. En esta página
     no hay un paso de "agregar" separado del de pagar: es la misma acción. Por
     eso add_to_cart_real nunca va a ser mayor que checkout, y para medir si la
     sesión avanzó conviene usar checkout. */
  function vigilarAgregar() {
    var orig = window.PT_addToCart;
    if (typeof orig !== 'function' || orig.__ptEmbudo) return false;
    var envuelta = function () {
      var st = window.state || {};
      emitirCada('add_to_cart_real', {
        plan: st.plan || null, cadence: st.cadence || null, zone: st.zona || null,
        /* Si esto sale sin view_price previo, es que el precio nunca llegó a
           estar en pantalla: sirve para detectar el problema, no para taparlo. */
        vio_precio: !!yaEmitido.view_price,
      });
      return orig.apply(this, arguments);
    };
    envuelta.__ptEmbudo = true;
    window.PT_addToCart = envuelta;
    return true;
  }

  /* ── 4. plan_viewed ───────────────────────────────────────────────────── */

  var yaAvisado = false;

  function planVisible() {
    var pb = document.getElementById('priceBlock');
    if (!pb) return false;
    if (getComputedStyle(pb).display === 'none') return false;
    var d = document.getElementById('pday');
    return !!(d && !enCero(d));   /* con precio de verdad, no el 0 inicial */
  }

  function avisarPlanViewed() {
    if (yaAvisado || !planVisible()) return;
    yaAvisado = true;
    var st = window.state || {};
    var tel = document.getElementById('leadPhone');
    var chk = document.getElementById('waMarketing');
    var pday = document.getElementById('pday');
    try {
      if (typeof window.PT_track === 'function') {
        window.PT_track('plan_viewed', {
          whatsapp_provided: !!(tel && String(tel.value || '').replace(/\D/g, '').length >= 10),
          marketing_consent: !!(chk && chk.checked),
          frequency: st.cadence || null,
          purchase_type: st.plan || null,
          price: pday ? pday.textContent : null,
          zone: st.zona || null,
          recipe: st.recetas ? Array.from(st.recetas).join('+') : null,
          form_id: window.PT_FORM_ID || null,
        });
      }
    } catch (e) {}
  }

  function arrancar() {
    vigilarPrecios();

    /* El precio aparece cuando el usuario avanza, así que se vigila en vez de
       comprobarlo una vez. */
    setInterval(vigilarPrecio, 700);
    vigilarPrecio();

    /* PT_addToCart la define pt-plan-builder al arrancar; si todavía no está,
       se reintenta un rato. */
    if (!vigilarAgregar()) {
      var n = 0;
      var t = setInterval(function () {
        if (vigilarAgregar() || ++n > 60) clearInterval(t);
      }, 500);
    }
    var raiz = document.getElementById('priceBlock');
    if (raiz) {
      new MutationObserver(avisarPlanViewed).observe(raiz, {
        subtree: true, childList: true, characterData: true, attributes: true,
      });
    }
    /* Red por si el precio ya estaba pintado antes de instalar el observador. */
    var n = 0;
    var t = setInterval(function () {
      avisarPlanViewed();
      if (yaAvisado || ++n > 120) clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
